import React from 'react';
import UserDropdown from './LoggedUser';
import CurrentLocation from './CurrentLocation';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import logo from '../../assets/img/horn.png';
import { useCart } from '../../hooks/useCart';
import { useWishlist } from '../../context/WishlistContext';
import { useUnreadCount } from '../../hooks/useNotifications';
import { useSiteSettings } from '../../hooks/useSiteSettings';
import { getSocialLinks } from '../../services/settings.service';


const Navbar = () => {
    // Cart hook must be called unconditionally at top level per React Hook rules
    const { totalItems } = useCart();
    const { count: wishlistCount } = useWishlist();
    const { user, isAuthenticated, logout, token } = useAuth();
    const { data: unreadCount = 0 } = useUnreadCount(isAuthenticated ? token : null);
    const { settings } = useSiteSettings();
    const socialLinks = getSocialLinks(settings);

    return (
        <header className="site-header site-header-transparent">
            {/* header html start */}
            <div className="upper-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 d-flex align-items-center header-banner-info justify-content-lg-start justify-content-around">
                            <p>Get started with us, You will need a good plan !</p>
                            <span className="start-btn">
                                <Link to="/contact">GET STARTED</Link>
                            </span>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-lg-end justify-content-center align-items-center header-location">
                            <i aria-hidden="true" className="fas fa-map-marker-alt" /> {settings.address1}
                        </div>
                        <div className="col-lg-3 d-flex justify-content-lg-end justify-content-center align-items-center header-location">
                            <CurrentLocation />
                        </div>
                    </div>
                </div>
            </div>
            <div className="top-header">
                <div className="container">
                    <div className="row align-items-center justify-content-lg-start">
                        <div className="site-identity col-lg-2 col-sm-12 col-6">
                            <p className="site-title">
                                <Link to="/">
                                    <img alt="Horn Petroleum logo" src={logo} />
                                </Link>
                            </p>
                        </div>
                        <div className="col-lg-8 col-sm-12 col-6 d-flex justify-content-lg-end justify-content-sm-around justify-content-end">
                            <div className="header-contact-info">
                                <ul>
                                    <li>
                                        <a href={`tel:${settings.phone1}`}>
                                            <span className="icon">
                                                <i aria-hidden="true" className="icon icon-phone" />
                                            </span>
                                            <div className="details-content">
                                                <span className="content-title">Call us now :</span>
                                                <h6>{settings.phone1}</h6>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href={`mailto:${settings.email1}`}>
                                            <span className="icon">
                                                <i aria-hidden="true" className="icon icon-envelope3" />
                                            </span>
                                            <div className="details-content">
                                                <span className="content-title">Email us now :</span>
                                                <h6>{settings.email1}</h6>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="header-social social-links d-flex align-items-center">
                                <ul className="mb-0">
                                    {socialLinks.map(item => (
                                        <li key={item.key}>
                                            <a href={item.url} target="_blank" rel="noreferrer" aria-label={item.label}>
                                                {item.iconText ? (
                                                    <span aria-hidden="true" className="social-letter-icon">{item.iconText}</span>
                                                ) : (
                                                    <i aria-hidden="true" className={item.icon} />
                                                )}
                                            </a>
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        </div>
                        <div className="col-lg-2  col-sm-12">
                            <div className="header-btn d-inline-block">
                                {isAuthenticated && (
                                    <div className="dropdown ms-3 user-dropdown">
                                        <UserDropdown
                                            username={user?.name || user?.username || 'Account'}
                                            logout={logout}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bottom-header" id="masthead">
                <div className="container">
                    <div className="hb-group d-flex align-items-center justify-content-between">
                        <div className="main-navigation col-lg-9 d-flex align-items-center">
                            <div className="logo-bottom-header">
                                <a href="index.html">
                                    <img alt="Horn Petroleum logo" src={logo} />
                                </a>
                            </div>
                            <nav className="navigation d-none d-lg-inline-block" id="navigation">
                                <ul>
                                    <li className="current-menu-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/products">Products</Link>
                                    </li>
                                    <li>
                                        <Link to="/tracking_orders">Tracking orders</Link>
                                    </li>
                                    {/*
                                    <li>
                                        <a href="about.html">About us</a>
                                    </li>
                                     */}
                                    <li>

                                        <Link to="/contact">Contact us</Link>
                                    </li>
                                    <li>

                                        <Link to="/about">About Us</Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div className="col-lg-3 col-12 d-flex justify-content-lg-end justify-content-between align-items-center">

                            {!isAuthenticated && (
                                <div className="header-btn d-inline-block">
                                    <Link className="button-round-gradient" to="/login">
                                        LOGIN/REGISTER
                                    </Link>
                                </div>
                            )}
                            {isAuthenticated && wishlistCount > 0 && (
                                <Link
                                    to="/account/wishlist"
                                    className="ms-2 small text-decoration-none"
                                    aria-label={`Wishlist (${wishlistCount})`}
                                >
                                    <span className="badge bg-light text-danger">
                                        {wishlistCount}
                                    </span>
                                </Link>
                            )}
                            {isAuthenticated && (
                                <Link
                                    to="/account/notifications"
                                    className="ms-2 position-relative d-inline-flex align-items-center"
                                    aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
                                    style={{ color: 'inherit', textDecoration: 'none' }}
                                >
                                    <i className="fa fa-solid fa-bell" style={{ fontSize: '1.15rem' }} />
                                    {unreadCount > 0 && (
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                            style={{ fontSize: '.6rem', minWidth: 18, padding: '2px 5px' }}
                                        >
                                            {unreadCount > 99 ? '99+' : unreadCount}
                                        </span>
                                    )}
                                </Link>
                            )}
                            <Link
                                to="/cart"
                                className="align-items-center button-round-gradient cart-num d-flex ms-3 rounded-0 position-relative cart-num"
                                aria-label={`Go to cart. You have ${totalItems} item${totalItems === 1 ? '' : 's'} in the cart`}
                            >
                                <i aria-hidden="true" className="fas fa-shopping-cart fa-lg" />
                                <div className="num position-absolute" data-testid="cart-count">{totalItems}</div>
                            </Link>

                        </div>
                    </div>
                </div>
                <div className="mobile-menu-container" />
            </div>
        </header>
    );
};

export default Navbar;
